import { render, staticRenderFns } from "./TooltipExclamation.vue?vue&type=template&id=be3f056e&scoped=true"
import script from "./TooltipExclamation.vue?vue&type=script&lang=js"
export * from "./TooltipExclamation.vue?vue&type=script&lang=js"
import style0 from "./TooltipExclamation.vue?vue&type=style&index=0&id=be3f056e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be3f056e",
  null
  
)

export default component.exports